// Note, in the future this may become a part of shared config space
export const Tags = {
  IFRAME: 'IFRAME',
  APP: 'APP',
  NAV: 'NAV'
};